import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { Slot } from '@utils/interfaces';
import { useState, useEffect } from 'react';
import { STATUS_ALERT } from '@components/CalendarPage/CalendarPage';
import { useOBQuery } from '@hooks/useOBQuery';

export interface CalendarRequest {
  practiceId: string;
  appointmentType?: string;
  insuranceSelected: string | undefined;
  previousExam: boolean;
  date: string | undefined;
  reservationStatus: STATUS_ALERT;
  practitionerId: string | undefined;
}

const useGetHourSlots = (props: CalendarRequest) => {
  const [practiceId, setPracticeId] = useState<string>(props.practiceId);
  const [appointmentType, setAppointmentType] = useState<string | undefined>(
    props.appointmentType,
  );
  const [insuranceSelected, setInsuranceSelected] = useState<
    string | undefined
  >(props.insuranceSelected);
  const [date, setDate] = useState<string | undefined>(props.date);
  const [reservationStatus, setReservationStatus] = useState<STATUS_ALERT>(
    props.reservationStatus,
  );
  const [practitionerId, setPractitionerId] = useState(props.practitionerId);

  const url = useApiUrl(
    OBRoutes.HourSlots,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )
    ?.replace('##practiceId', practiceId)
    ?.concat(
      `?appointmentType=${appointmentType}` +
        `&insuranceSelected=${insuranceSelected}` +
        `&date=${date}` +
        (practitionerId ? `&practitionerId=${practitionerId}` : '') +
        `&previousExam=${props.previousExam}`,
    );

  useEffect(() => {
    setPracticeId(props.practiceId);
    setAppointmentType(props.appointmentType);
    setInsuranceSelected(props.insuranceSelected);
    setDate(props.date);
    setReservationStatus(props.reservationStatus);
    setPractitionerId(props.practitionerId);
    console.log('#Calendar | useGetHourSlots :', props.date);
  }, [
    props.practiceId,
    props.appointmentType,
    props.insuranceSelected,
    props.date,
    props.reservationStatus,
    props.practitionerId,
  ]);

  return useOBQuery<Slot[]>(url, {
    enabled: !!(
      practiceId &&
      appointmentType &&
      (insuranceSelected || insuranceSelected === '') &&
      date &&
      (reservationStatus === STATUS_ALERT.HAPPY_FLOW ||
        reservationStatus === STATUS_ALERT.DAY_AVAILABLE ||
        reservationStatus === STATUS_ALERT.SLOT_AVAILABLE)
    ),
  });
};

export default useGetHourSlots;
